<div class="row" style="min-height: 150px;">
  <div class="col">
    <div class="row">
      <div class="col">
        <div class="inline-block deviceOptionsHeader">
          <sb-icon class="blue" icon="download"></sb-icon>&nbsp;
        </div>
        <div class="blue inline-block deviceOptionsHeader">
          {{ 'lang.globals.export' | translate }}&nbsp;
          <ng-container *ngIf="exportOptions?.kind">
            <ng-container [ngSwitch]="exportOptions.kind">
              <ng-container *ngSwitchCase="'DEVICE_LOG'">({{'lang.deviceDetails.logHeadline' |
                translate}})
              </ng-container>
              <ng-container *ngSwitchCase="'DEVICE_PLAYOUTS'">({{'lang.globals.playouts' |
                translate}})
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tablewrap">
          <div class="d-flex flex-row bb">
            <div
              class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
              <p class="w-100 tc">
                <sb-date-time-range-input id="validity" class="mr-2" [today]="undefined"
                                          (dateChange)="handleDateChange($event)"></sb-date-time-range-input>
              </p>
            </div>
          </div>
          <div class="d-flex flex-row bb" *ngIf="exportOptions?.kind === 'DEVICE_LOG'">
            <div
              class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
              <p class="w-100 tc">
                <sb-comp-dropdown-select class="mr-1" (msOptionsChange)="msRequest($event)"
                                         (selectedDataEmitter)="msUpdate($event)" [dropDownDatatype]="'DEVICE_LOG_DATATYPES'"
                                         [inputData]="datatypes" [msOptions]="msDatatypeOptions"
                                         [selectedInputData]="filteredDatatypes" [showColumnIcon]="true" [showSubmit]="true">
                </sb-comp-dropdown-select>
              </p>
            </div>
          </div>
          <div class="d-flex flex-row bb">
            <div
              class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
              <p class="w-100 tc">
                <sb-button classes="btn-primary" (click)="export()" [disabled]="loading"
                           [loading]=loading>
                  &nbsp;<sb-icon icon="download"></sb-icon>&nbsp;{{
                  'lang.globals.export' | translate }}
                </sb-button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
